<template>
	<div class="modal-step-two">
		<div class="modal-step-two-wrap">
			<v-layout row wrap align-center class="modal-step-two-header">
				<v-flex xs10 md6>
					<span>{{ addressLocation }}</span>
				</v-flex>
				<v-flex xs2 md4>
					<v-btn
						class="ma-0 btn-change-location"
						depressed
						flat
						@click="$emit('change-location')"
					>
						<span class="w-semibold white--text hidden-sm-and-down">
							<img
								src="/static/images-new/icons/icon-change.svg"
								alt="cambiar ubicación"
								height="13"
								class="mr-2"
							/>
							Cambiar
						</span>
						<img
							class="hidden-md-and-up"
							src="/static/images-new/icons/icon-config-location-orange.svg"
							alt="cambiar ubicación"
							height="26"
						/>
					</v-btn>
				</v-flex>
			</v-layout>
			<v-layout row wrap class="modal-step-two-body">
				<v-flex xs12 md6 class="modal-step-two-colleft">
					<v-text-field
						class="input-location input-location-primary input-location-two"
						hide-details
						prepend-icon="location_on"
						:placeholder="countryCode === 'PE' ? 'Dirección exacta' : 'Referencia, conjunto, nro. de casa'"
						:value="address"
						@input="$emit('get-data', { model: 'address', value: $event })"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md4 class="modal-step-two-colmiddle">
					<v-text-field
						class="input-location input-location-primary input-location-two pl-4"
						hide-details
						placeholder="¿Qué lugar es este?"
						:value="alias"
						@input="$emit('get-data', { model: 'alias', value: $event })"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md2 class="modal-step-two-colright">
					<v-btn
						class="ma-0 btn-save"
						depressed
						:disabled="!address || !alias"
						flat
						@click="$emit('save-location')"
					>
						<span class="w-bold white--text">Guardar</span>
						<span class="w-bold white--text hidden-md-and-up pl-1">dirección</span>
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
		<img
			class="marker-icon"
			src="/static/images-new/icons/marker-market-place.png"
			alt="marcador mapa"
		/>
		<gmap-component
			:center="settings.center"
			:height="settings.height"
			:markers="settings.markers"
			:unit-height="settings.unitHeight"
			:unit-width="settings.unitWidth"
			:width="settings.width"
			:zoom="settings.zoom"
			@on-center-changed="$emit('on-center-changed', $event)"
		></gmap-component>
	</div>
</template>

<script>
	import gmapComponent from '@/components/shared/gmap-component';

	export default {
		name: 'modal-step-two',
		components: {
			gmapComponent,
		},
		props: {
			address: String,
			addressLocation: String,
			alias: String,
			countryCode: String,
			settings: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.marker-icon {
		bottom: 36vh;
		height: 64px;
		left: 0;
		margin: auto;
		position: absolute;
		right: 0;
		z-index: 1;

		@media (min-width: 936px) {
			height: 94px;
		}
	}

	.modal-step-two {
		&-wrap {
			border-radius: 17px;
			box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.24);
			left: 0px;
			margin: 0px auto;
			position: absolute;
			right: 0px;
			top: 12px;
			width: 92%;
			z-index: 1;

			@media (min-width: 936px) {
				box-shadow: none;
				top: 0px;
				width: 100%;
			}
		}

		&-header {
			background-color: color(background-modal);
			border-top-left-radius: 17px;
			border-top-right-radius: 17px;
			color: color(primary);
			font-size: size(medium);
			font-weight: weight(semibold);
			min-height: 57px;
			padding: 14px 0px 14px 28px;

			@media (min-width: 936px) {
				border-top-left-radius: 2px;
				border-top-right-radius: 2px;
				min-height: 60px;
				padding: 18px 31px;
			}
		}

		&-body {
			background-color: color(white);
			border-bottom-left-radius: 17px;
			border-bottom-right-radius: 17px;
			box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.11);
			padding: 11px 14px 16px;

			@media (min-width: 936px) {
				border-bottom-left-radius: 0px;
				border-bottom-right-radius: 0px;
				padding: 14px 28px 28px;
			}
		}

		&-colleft {
			@media (min-width: 936px) {
				padding-right: 10px;
			}
		}

		&-colmiddle {
			margin: 11px 0px;

			@media (min-width: 936px) {
				margin: 0px;
			}
		}

		&-colright {
			@media (min-width: 936px) {
				padding-left: 10px;
			}
		}
	}

	.vue-map-container {
		left: 0px !important;
		position: absolute !important;
		top: 0px !important;
	}

	.btn-change-location {
		height: auto !important;
		min-width: auto !important;
		width: auto !important;

		@media (min-width: 936px) {
			background-color: color(newprimary) !important;
			border-radius: 12.5px;
			height: 25px !important;
			width: 85px !important;
		}
	}

	.btn-save {
		background-color: color(newprimary) !important;
		border-radius: 25px;
		height: 50px !important;
		width: 100% !important;
	}

	.input-location {
		border: 1px solid color(border-modal);
		border-radius: 25px;
		height: 50px;
		margin: 0 auto;
		padding-left: 11px;
		padding-top: 0px;
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/modal-step-two.vue